/**
 * How a blocked held row shows on the quantity grid, the way the review page shows the same
 * issues: greyed like an instrument that cannot be held, and out of reach of every bulk action.
 */
import type { RowClassRules, RowSelectionOptions } from "ag-grid-community";
import type { Instrument } from "../../const";
import { isHeldBlocked } from "./heldIssue";

const GREYED_ROW = "bg-[var(--Table-highlightedRowBackgroundColor)]";

/** `rules` with a blocked held row greyed, on top of whatever greys a row already. */
export function withHeldBlockedRowClasses(rules: RowClassRules<Instrument>): RowClassRules<Instrument> {
	const existing = rules[GREYED_ROW];
	return {
		...rules,
		[GREYED_ROW]: (params) =>
			(typeof existing === "function" && Boolean(existing(params))) ||
			(params.data != null && isHeldBlocked(params.data)),
	};
}

/**
 * `guard` with a blocked held row made unselectable, its checkbox hidden — so no bulk action,
 * removal included, reaches it.
 */
export function withHeldBlockedUnselectable<T extends Partial<RowSelectionOptions<Instrument>>>(guard: T): T {
	const { isRowSelectable } = guard;
	return {
		...guard,
		hideDisabledCheckboxes: true,
		isRowSelectable: (node) =>
			!(node.data != null && isHeldBlocked(node.data)) && (isRowSelectable ? isRowSelectable(node) : true),
	};
}
